import { render } from "./InvoiceTerms.vue?vue&type=template&id=2f1b34e1&scoped=true&ts=true&lang=pug"
import script from "./InvoiceTerms.vue?vue&type=script&lang=ts"
export * from "./InvoiceTerms.vue?vue&type=script&lang=ts"

import "./InvoiceTerms.vue?vue&type=style&index=0&id=2f1b34e1&scoped=true&lang=stylus"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1b34e1"]])

export default __exports__